import axios from "axios";
import { baseUrl } from "../util";

const getConfig = () => ({
  headers: {
    Authorization: `Bearer ${localStorage.getItem("access_token")}`,
    "Content-Type": "application/json",
  },
});

export const componentSubcategoryService = {
  getComponentSubs: async (productId) => {
    try {
      const response = await axios.get(
        `${baseUrl}/api/business/product/${productId}/component-sub/`,
        getConfig()
      );
      return response.data.data;
    } catch (error) {
      console.error("Error fetching component-sub:", error);
      throw error;
    }
  },

  createComponentSub: async (productId, componentSubData) => {
    try {
      const response = await axios.post(
        `${baseUrl}/api/business/product/${productId}/component-sub/`,
        componentSubData,
        getConfig()
      );
      return response.data.data;
    } catch (error) {
      console.error("Error creating team:", error);
      throw error;
    }
  },

  updateComponentSub: async (productId, subId, componentSubData) => {
    try {
      const response = await axios.put(
        `${baseUrl}/api/business/product/${productId}/component-sub/${subId}/`,
        componentSubData,
        getConfig()
      );
      return response.data.data;
    } catch (error) {
      console.error("Error updating team:", error);
      throw error;
    }
  },

  deleteComponentSub: async (productId, subId) => {
    try {
      const response = await axios.delete(
        `${baseUrl}/api/business/product/${productId}/component-sub/${subId}/`,
        getConfig()
      );
      return response.status === 204;
    } catch (error) {
      console.error("Error deleting team:", error);
      throw error;
    }
  },
};
